import { render, staticRenderFns } from "./ChainStatsRow.vue?vue&type=template&id=6cb255b0&scoped=true&"
import script from "./ChainStatsRow.vue?vue&type=script&lang=js&"
export * from "./ChainStatsRow.vue?vue&type=script&lang=js&"
import style0 from "./ChainStatsRow.vue?vue&type=style&index=0&id=6cb255b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb255b0",
  null
  
)

export default component.exports